import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Form, FormSelect, Grid, Header, Icon, Menu, Modal, Popup, Select } from 'semantic-ui-react';
import { history } from '../../store/configureStore';
import { TextLink } from '../verizon/TextLink';
import { getSelectedLocation, redirectTo, roles, userAllowed } from '../../helpers/utils';
import appLauncher from '../../semantic-ui/site/assets/icons/nav/app-launcher.svg';
import notification from '../../semantic-ui/site/assets/icons/nav/notification.svg';
import help from '../../semantic-ui/site/assets/icons/nav/question.svg';
import support from '../../semantic-ui/site/assets/icons/nav/support.svg';
import ticket from '../../semantic-ui/site/assets/icons/nav/add-ticket.svg';
import userProfile from '../../semantic-ui/site/assets/icons/nav/my-account.svg';
import './PageNav.less';
import { CREATE_TICKET_URL, THINGSPACE_URL, MY_BIZ_URL, EDGE_DEVELOPER_URL, FEEDBACK_FORM_URL } from '../../helpers/const';
import ConfirmMessage from '../ConfirmMessage';
import NotificationComponent from '../notification/NotificationComponent';
import { getUserNotifications } from '../../actions/users';
import { updateNotificationCount } from '../../actions/notifications';
import { adminLogin } from '../../actions/auth';
import feedback from '../../semantic-ui/site/assets/feedback_blk.svg';
import { osndLocalStorage, storageConstant } from '../../helpers/localStorageUtils';
import { ENABLE_VIDEO_GUIDE } from '../../helpers/featureFlags';

const PageNav = (props) => {
    const dispatcher = useDispatch();
    const { location, setShowMobileSubNav, showEnterpriseSelection } = props;
    const { signedIn, roles: userRoles, enterpriseId, linkedEnterprises, currentLocation, admin = false } = useSelector((state) => state.auth);
    const { count } = useSelector((state) => state.notifications);
    const [confirmLogout, setConfirmLogout] = useState(false);
    const [supportPopup, setSupportPopup] = useState(false);
    const [showAllLocationsModal, setAllLocationsModal] = useState(false);
    const [notificationPopup, setNotificationPopup] = useState(false);
    const isMultiNibAllowed = userAllowed(userRoles, [roles.MANAGE_MULTI_NIB_COMBINED_VIEW]);
    const selectedLocation = getSelectedLocation();
    const locationOptions = linkedEnterprises?.map((link) => ({
        key: link.enterpriseId,
        value: link.enterpriseId,
        text: link.siteName || link.enterpriseName
    }));

    useEffect(() => {
        fetchInit();
    }, []);

    const fetchInit = async () => {
        try {
            const response = await dispatcher(getUserNotifications());
            updateNotificationCount(dispatcher, response?.data?.uncheckedNotifications + response?.data?.uncheckedFutureNotifications);
        } catch ({ message }) {
            console.error(message);
        }
    };

    const toggleMobileSubNav = useCallback(() => {
        setShowMobileSubNav(true);
    }, []);

    const onClickGoTo = useCallback((event, { value }) => {
        history.push(value);
    }, []);
    const onSupportClick = () => {
        setSupportPopup(true);
    };
    const onLogoutClick = () => {
        setConfirmLogout(true);
    };
    const logout = () => {
        redirectTo('/logout');
    };

    const onNotifictionClick = () => {
        setNotificationPopup(!notificationPopup);
    };

    const updateSelectedEnterprise = (enterpriseId) => {
        const linkedEnterprises = osndLocalStorage.getArray(storageConstant.LINKED_ENTERPRISES);
        if (linkedEnterprises?.length > 0) {
            linkedEnterprises.forEach((element) => {
                element.selected = element.enterpriseId === enterpriseId;
            });
            osndLocalStorage.setArray(storageConstant.LINKED_ENTERPRISES, linkedEnterprises);
        }
    };

    const refreshNewLocation = (newLocation) => {
        const linkedEnterprises = osndLocalStorage.getArray(storageConstant.LINKED_ENTERPRISES);
        if (linkedEnterprises?.length > 0) {
            const newEnterpriseId = newLocation === 'all_locations' ? enterpriseId : newLocation;
            //navigate to dashboard
            history.replace(`/#${newEnterpriseId}`);
        }
    };

    const loadEnterprise = async (enterpriseId) => {
        updateSelectedEnterprise(enterpriseId);
        if (enterpriseId !== 'all_locations') {
            const location = linkedEnterprises.find((el) => el?.enterpriseId === enterpriseId);
            if (location?.enterpriseId) {
                const response = await dispatcher(
                    adminLogin({ id: location?.enterpriseId, name: location?.enterpriseName, ecpdId: location?.ecpdId })
                );
                if (response?.enterpriseId) {
                    refreshNewLocation(enterpriseId);
                }
            }
        } else {
            refreshNewLocation(enterpriseId);
        }
    };

    const onLocationChanged = async (event, { value }) => {
        if (value === 'all_locations') {
            setAllLocationsModal(true);
            return;
        }
        await loadEnterprise(value);
    };

    const onSubmitYes = async () => {
        await loadEnterprise('all_locations');
        setAllLocationsModal(false);
    };

    const handleClose = () => {
        setAllLocationsModal(false);
    };

    return location.pathname !== '/login' && signedIn ? (
        <>
            <Grid.Column textAlign="right" only="computer">
                <Menu text className="header-nav tour-step-1 no-print">
                    {isMultiNibAllowed && !showEnterpriseSelection && locationOptions?.length > 1 ? (
                        <Menu.Item>
                            <Form>
                                <Form.Group style={{ marginBottom: 0 }}>
                                    <span style={{ fontSize: 16, fontWeight: 600, marginTop: 12 }}>Location: </span>
                                    <FormSelect
                                        control={Select}
                                        name="location"
                                        options={locationOptions}
                                        value={selectedLocation?.enterpriseId}
                                        onChange={onLocationChanged}
                                    />
                                </Form.Group>
                            </Form>
                        </Menu.Item>
                    ) : null}
                    <Menu.Item onClick={onNotifictionClick} disabled={showEnterpriseSelection}>
                        <Popup
                            className="notifn-popup"
                            content={<NotificationComponent />}
                            on="click"
                            position="bottom center"
                            style={{
                                textAlign: 'left',
                                border: 'none',
                                borderRadius: '5px',
                                boxShadow: '0 2px 6px -1px #999'
                            }}
                            trigger={
                                <div>
                                    <img src={notification} />
                                    <span className="notification-badge">{count || 0}</span>
                                </div>
                            }></Popup>
                    </Menu.Item>
                    <Menu.Item onClick={onSupportClick}>
                        <img src={support} />
                    </Menu.Item>
                    {admin && <Menu.Item onClick={() => redirectTo(FEEDBACK_FORM_URL + window.location?.host + window.location?.pathname, true)}>
                            <img src={feedback} width={24} height={24} className="feedback-icon"></img>
                    </Menu.Item>}
                    <Menu.Item onClick={() => redirectTo(CREATE_TICKET_URL, true)} disabled={showEnterpriseSelection}>
                        <img src={ticket} />
                    </Menu.Item>
                    <Menu.Item disabled={showEnterpriseSelection}>
                        <Dropdown className="add-liner" trigger={<img src={appLauncher} />} icon={null}>
                            <Dropdown.Menu>
                                <Dropdown.Item text="My business" onClick={() => redirectTo(MY_BIZ_URL, true)} />
                                <Dropdown.Item text="5G edge developer" onClick={() => redirectTo(EDGE_DEVELOPER_URL, true)} />
                                <Dropdown.Item text="ThingSpace manage" onClick={() => redirectTo(THINGSPACE_URL, true)} />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item>
                        <Dropdown className="add-liner" trigger={<img src={help} />} icon={null}>
                            <Dropdown.Menu>
                                <Dropdown.Item text="Download PDF guide" onClick={() => redirectTo('/help')} />
                                {ENABLE_VIDEO_GUIDE && <Dropdown.Item text="Video guide" onClick={() => redirectTo('/video/guide')} />}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item>
                        <Dropdown trigger={<img src={userProfile} />} icon={null}>
                            <Dropdown.Menu>
                                <Dropdown.Item text="Logout" onClick={onLogoutClick} />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                </Menu>
                {confirmLogout && (
                    <ConfirmMessage
                        open
                        message={
                            <>
                                <h2>Are you sure?</h2>
                                <div>Clicking confirm will logout from OSND and MyBiz.</div>
                            </>
                        }
                        confirmBtnText="Confirm"
                        cancelBtnText="Take me back"
                        handleClose={() => setConfirmLogout(false)}
                        handleConfirm={logout}
                        size="tiny"
                    />
                )}

                {supportPopup && (
                    <ConfirmMessage
                        open
                        message={
                            <>
                                <h2>Support</h2>
                                <hr />
                                <div>24x7 Customer service number:</div>
                                <h1>800-525-0481</h1>
                                <div>
                                    Select prompt <strong>6</strong>, enter extension <strong>7483</strong> when prompted.
                                </div>
                            </>
                        }
                        size="tiny"
                        handleClose={() => setSupportPopup(false)}
                        closeIcon={true}
                        hideActions={true}
                    />
                )}
                {!userAllowed(userRoles, [roles.ADMIN_USER]) && (
                    <TextLink className="portal no-print" value="/portal" onClick={onClickGoTo}>
                        Back to Portal
                    </TextLink>
                )}
            </Grid.Column>
            <Grid.Column textAlign="right" only="mobile tablet">
                <TextLink className="mobile-nav no-print" icon={<Icon className="menu" />} onClick={toggleMobileSubNav} />
            </Grid.Column>
            {showAllLocationsModal && (
                <Modal className="all-locations-modal" open closeIcon size="tiny" onClose={handleClose}>
                    <Header className="all-location-model-header">Are you sure?</Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Row>
                                By selecting the All locations option you will be redirected to the Dashboard and lose any and all data you may not
                                have saved.
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button content="Yes, show me all locations" onClick={onSubmitYes} />
                        <Button secondary onClick={handleClose}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
            )}
        </>
    ) : null;
};

export default PageNav;
